import { render, staticRenderFns } from "./DashboardSwitcher.vue?vue&type=template&id=5c2bde8b&scoped=true"
import script from "./DashboardSwitcher.vue?vue&type=script&lang=js"
export * from "./DashboardSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2bde8b",
  null
  
)

export default component.exports